import {
  API_CLIENTS,
  API_KEY,
  // LINKS_CLIENTS,
  API_CLIENTS_DELETE,
  API_CLIENTS_EDIT,
  API_POSTS_COUNT,
  API_FACEBOOK_PAGES,
  API_GET_CLIENT_BY_EMAIL
} from '../../utils/constants';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import AWS_Lambda from '../../aws/aws';

import { accountManagers } from '../../utils';
const axios = require('axios');

// Endpoint for getting client by email
const GET_CLIENT_BY_EMAIL = API_GET_CLIENT_BY_EMAIL;

// Get all the clients
export const getClients = createAsyncThunk(
  'clients/logoutUser',
  async (payload, { getState, requestId, rejectWithValue }) => {
    const { userInfo } = getState().auth;

    try {
      return await axios
        .all([
          axios.get(API_CLIENTS, { headers: { 'X-API-KEY': API_KEY } }),
          axios.get(API_FACEBOOK_PAGES, {
            headers: {
              Authorization: `bearer ${userInfo.accessToken}`
            }
          })
        ])
        .then(
          axios.spread(async (response, response3) => {
            let clients = response.data.clients;

            let clientsListWithGroups = clients.map(function (client, index) {
              let likesPerClient;
              let reachedPerClient;
              let engagementPerClient;

              response3.data.pages.forEach((datos) => {
                if (
                  client.active !== false &&
                  client.socialnetworks.facebookPage === datos.entity_name
                ) {
                  likesPerClient = {
                    client: client.clientName,
                    likes: datos.country_page_likes
                  };
                  reachedPerClient = {
                    client: client.clientName,
                    reached: datos.reached,
                    reachedPercentage: datos.reachedPercentage
                  };
                  engagementPerClient = {
                    client: client.clientName,
                    engagement: datos.engament,
                    engagementPercentage: datos.engamentPercentage
                  };
                }
              });

              let accountOwnerFullName = accountManagers.find(
                (item) => item.id === client.accountOwner
              )?.full_name;

              let clientGrp = null;

              if (typeof client.clientGroups === 'undefined') {
                clientGrp = 'None';
              }

              if (typeof client.clientGroups === 'object') {
                if (client.clientGroups.hasOwnProperty('groupName')) {
                  clientGrp = client.clientGroups.groupName;
                } else {
                  let groupsFromArray = client.clientGroups.map(
                    (item) => item.groupName
                  );
                  clientGrp = groupsFromArray.join(', ');
                }
              }

              return {
                id: client.id,
                clientName: client.clientName,
                firstGenerationByAI: client.firstGenerationByAI,
                clientGroups: clientGrp,
                clientSocialNetworks: client.socialnetworks,
                clientFlags: client.clientFlags,
                timeZone: client.timeZone,
                bestTimes: client.bestTimes,
                appActive: client.appActive,
                appUid: client.appUid,
                smsCount: client.smsCount,
                mergeFields: client.mergeFields,
                gmbId: client.gmbId,
                yelpId: client.yelpId,
                likesFacebook: likesPerClient,
                reachedFacebook: reachedPerClient,
                engagementFacebook: engagementPerClient,
                trained: client.trained,
                accountOwner: client.accountOwner,
                accountOwnerFullName: accountOwnerFullName,
                accountStatus: client.accountStatus,
                gmbInfo: client?.gmbInfo || null,
                yelpInfo: client?.yelpInfo || null,
                createdAt: client.createdAt,
                singlePerson: client.singlePerson,
                logoUrl: client.logoUrl || null
              };
            });
            return clientsListWithGroups;
          })
        )
        .catch(function (error) {
          console.error('error getting clients', error);
          return [];
        });
    } catch (error) {
      console.error('error in multiple promises ', error);
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete a client
export const deleteClient = createAsyncThunk(
  'clients/deleteClient',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const { loadingClients } = getState().clients;
      const { userInfo } = getState().auth;

      if (!loadingClients) {
        return;
      }

      let res = await axios.post(API_CLIENTS_DELETE, payload, {
        headers: {
          Authorization: `bearer ${userInfo.accessToken}`
        }
      });
      if (res.status === 200) return true;
      else return false;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Update a client
export const updateClient = createAsyncThunk(
  'clients/updateClient',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const { loadingClients } = getState().clients;
      if (!loadingClients) {
        return;
      }
      let res = await axios.post(API_CLIENTS_EDIT, payload);
      if (res.status === 200) return true;
      else throw new Error('Could not update client');
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get client by id
export const getClientById = createAsyncThunk(
  'clients/getClientById',
  async ({ clientId, options = {} }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_CLIENTS}/${clientId}`, {
        headers: {
          'X-API-KEY': API_KEY
        },
        ...options
      });
      return response.data;
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') {
        throw error;
      }
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get client by id
export const getCountersById = createAsyncThunk(
  'clients/getCountersById',
  async ({ id, options = {} }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_POSTS_COUNT}/${id}`, {
        headers: {
          'X-API-KEY': API_KEY
        },
        ...options
      });
      return response.data;
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') {
        throw error;
      }
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get client by email (for app users login)
export const getClientByEmail = createAsyncThunk(
  'clients/getClientByEmail',
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        GET_CLIENT_BY_EMAIL,
        {
          email
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching client by email:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const slice = createSlice({
  name: 'clients',
  initialState: {
    customerList: [],
    selectedClient: null,
    currentRequestId: undefined,
    loadingClients: true,
    errorClients: null
  },
  reducers: {
    clearClientData: (state) => {
      state.selectedClient = null;
      state.loadingClients = false;
      state.errorClients = null;
      // Limpiar localStorage
      try {
        localStorage.removeItem('selectedClient');
      } catch (error) {
        console.error(
          'Error removing selectedClient from localStorage:',
          error
        );
      }
    },
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload;
    }
  },
  extraReducers: {
    [getClientById.pending]: (state, action) => {
      if (!state.loadingClients) {
        state.loadingClients = true;
        state.currentRequestId = action.meta.requestId;
      }
    },
    [getClientById.fulfilled]: (state) => {
      if (state.loadingClients) {
        state.loadingClients = false;
        state.errorClients = null;
      }
    },
    [getClientById.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loadingClients && state.currentRequestId === requestId) {
        state.loadingClients = false;
        state.errorClients = action.error;
        state.currentRequestId = undefined;
      }
    },
    [getCountersById.pending]: (state, action) => {
      if (!state.loadingClients) {
        state.loadingClients = true;
        state.currentRequestId = action.meta.requestId;
      }
    },
    [getCountersById.fulfilled]: (state, action) => {
      if (state.loadingClients) {
        state.loadingClients = false;
        state.errorClients = null;
      }
    },
    [getCountersById.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loadingClients && state.currentRequestId === requestId) {
        state.loadingClients = false;
        state.errorClients = action.error;
        state.currentRequestId = undefined;
      }
    },
    [getClients.pending]: (state, action) => {
      if (!state.loadingClients) {
        state.loadingClients = true;
        state.currentRequestId = action.meta?.requestId;
      }
    },
    [getClients.fulfilled]: (state, action) => {
      if (state.loadingClients) {
        state.customerList = action.payload;
        state.loadingClients = false;
        state.errorClients = null;
      }
    },
    [getClients.rejected]: (state, action) => {
      if (state.loadingClients) {
        state.customerList = [];
        state.loadingClients = false;
        state.errorClients = action.error;
        state.currentRequestId = undefined;
      }
    },
    [deleteClient.pending]: (state, action) => {
      if (!state.loadingClients) {
        state.loadingClients = true;
        state.currentRequestId = action.meta.requestId;
      }
    },
    [deleteClient.fulfilled]: (state, action) => {
      if (state.loadingClients) {
        state.loadingClients = false;
        state.errorClients = null;
      }
    },
    [deleteClient.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loadingClients && state.currentRequestId === requestId) {
        state.customerList = null;
        state.loadingClients = false;
        state.errorClients = action.error;
        state.currentRequestId = undefined;
      }
    },
    [updateClient.pending]: (state, action) => {
      if (!state.loadingClients) {
        state.loadingClients = true;
        state.currentRequestId = action.meta.requestId;
      }
    },
    [updateClient.fulfilled]: (state, action) => {
      if (state.loadingClients) {
        state.loadingClients = false;
        state.errorClients = null;
      }
    },
    [updateClient.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loadingClients && state.currentRequestId === requestId) {
        state.customerList = null;
        state.loadingClients = false;
        state.errorClients = action.error;
        state.currentRequestId = undefined;
      }
    },
    [getClientByEmail.pending]: (state, action) => {
      state.loadingClients = true;
      state.currentRequestId = action.meta.requestId;
    },
    [getClientByEmail.fulfilled]: (state, action) => {
      state.selectedClient = action.payload;
      state.loadingClients = false;
      state.errorClients = null;
      // Guardar en localStorage como backup
      try {
        localStorage.setItem('selectedClient', JSON.stringify(action.payload));
      } catch (error) {
        console.error('Error saving selectedClient to localStorage:', error);
      }
    },
    [getClientByEmail.rejected]: (state, action) => {
      state.selectedClient = null;
      state.loadingClients = false;
      state.errorClients = action.payload;
      state.currentRequestId = undefined;
    }
  }
});

export const { clearClientData, setSelectedClient } = slice.actions;

// Validar si hay cliente seleccionado en localStorage
export const validateSelectedClient = () => {
  return (dispatch, getState) => {
    const { auth, clients } = getState();

    // Solo validar si el usuario está logueado y es un app-user
    if (auth.isAuthenticated && auth.userInfo?.role === 'app-user') {
      // Si no hay selectedClient en Redux, intentar recuperar de localStorage
      if (!clients.selectedClient) {
        try {
          const savedClient = localStorage.getItem('selectedClient');
          if (savedClient) {
            const clientData = JSON.parse(savedClient);
            dispatch(setSelectedClient(clientData));
            return true;
          } else {
            // No hay cliente en localStorage, cerrar sesión
            console.warn(
              'No selectedClient found in localStorage, logging out...'
            );
            return false;
          }
        } catch (error) {
          console.error(
            'Error reading selectedClient from localStorage:',
            error
          );
          return false;
        }
      }
      return true;
    }
    return true;
  };
};

export default slice.reducer;

// Clients selector
export const clientsSelector = (state) => state.clients;
